import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';

import {
  GET_PROVEEDORES_REQUEST,
} from '../../actions/constants/proveedores/proveedores.constants';
import { authRequest } from '../../../helpers/request.helper';
import {
  getProveedoresFailureAction,
  getProveedoresSuccessAction,
} from '../../actions/creators/proveedores/proveedores.actioncreator';

const getProveedoresFromState = state => state.proveedores;

function* getProveedores(action) {
  const { payload } = action;
  const {
    page, start, limit, sede, estado, tipoListado, busqueda, proveedoresSeleccionados,
  } = payload;
  let url = `AplicacionesQ.proveedor/?page=${page}&start=${start}&limit=${limit}&sede_seleccionada=${sede}&estado=${estado}&tipo_listado=${tipoListado}`;

  const filtros = [];
  const hayBusqueda = busqueda !== null && busqueda !== '';
  if (hayBusqueda) {
    filtros.push({
      property: 'busqueda', value: busqueda, operator: 'like',
    });
  }

  if (proveedoresSeleccionados.length > 0) {
    filtros.push({
      property: 'proveedores_seleccionados', value: proveedoresSeleccionados, operator: 'in',
    });
  }

  const queryString = encodeURIComponent(JSON.stringify(filtros));
  url += `&filter=${queryString}`;

  const params = {
    url,
    method: 'GET',
  };

  try {
    const response = yield call(authRequest, params);
    const { datos, success, total } = response;
    if (success) {
      const proveedoresFromState = yield select(getProveedoresFromState);

      yield put(getProveedoresSuccessAction(datos, total, page, start, limit));
    } else {
      yield put(getProveedoresFailureAction());
    }
  } catch (error) {
    yield put(getProveedoresFailureAction(error));
  }
}

export function* getProveedoresRequest() {
  yield takeLatest(GET_PROVEEDORES_REQUEST, getProveedores);
}
